import {defineMessages} from 'react-intl';

export default defineMessages({
  noCurrency: {
    id: 'StoreConfigModal.currencies.none',
    defaultMessage: 'Event currency (no price conversion)',
  },
  languageInput: {
    id: 'StoreConfigModal.input.language',
    defaultMessage: 'Language',
  },
  currenciesInput: {
    id: 'StoreConfigModal.input.currencies',
    defaultMessage: 'Currencies',
  },
});
